export class Environments {
  public static HOST = process.env.NEXT_PUBLIC_HOST;
  public static PUBLIC_API = process.env.NEXT_PUBLIC_API;
  public static INTERNAL_API = process.env.INTERNAL_API;
  public static PUBLIC_NEW_API = process.env.NEXT_PUBLIC_NEW_API;
  public static PUBLIC_PLATFORM_API = process.env.NEXT_PUBLIC_PLATFORM_API;
  public static INTERNAL_NEW_API = process.env.INTERNAL_NEW_API;
  public static PUBLIC_UNLOCKED_FORMS_API=process.env.NEXT_PUBLIC_UNLOCKED_FORMS_API;
}
